module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Layout/Layout-left-panel-1-0bb50ae12e635e27bfd9e7cdc65e44d3.svg";